import { fileToDataUrl } from './fileConverter'

export async function loadImageFromFile(file: File) {
  const dataUrl = await fileToDataUrl(file)
  return await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = (e) => reject(e)
    image.src = dataUrl
  })
}
